/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of  InventoryPurchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BloodBankModuleApi } from '../api/blood-bank.api';
import { BloodBankModuleData } from '../interface/blood-bank';

@Injectable()
export class  BloodBankModuleService extends  BloodBankModuleData {

  constructor(private api:  BloodBankModuleApi) {
    super();
  }

  list(url: string): Observable< any[]> {
    return this.api.list(url);
  }
  searchList(url: string,data:any): Observable<any> {
    return this.api.searchList(url,data);
  }

  getById(url:string): Observable< any>{
      return this.api.getById(url);
  }

  create(url: string, data: any): Observable< any> {
    return this.api.create(url,data);
  }

  update(url: string, data: any): Observable< any> {
    return this.api.update(url,data);
  }
  
  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }

}
